// src/components/admin/PhraseItem.js
import { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api'; // ✅ Используем api

const PhraseItem = ({ phrase, theme, projectId, onEdit, onDelete }) => {
  const { user } = useAuth();
  const [text, setText] = useState(phrase.text);
  const [group, setGroup] = useState(phrase.group || 1);
  const roleNames = new Set(user?.roles?.map(r => r.name) || []);
  // Обновить фразу
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/admin/analytics/phrase/${phrase.id}`, {
        text,
        group: theme.absolutely_everything ? Number(group) : undefined,
        theme_id: theme.id, // нужно для проверки absolutely_everything на бэкенде
      });
      onEdit(); // Обновить список (например, перезагрузить тему)
    } catch (err) {
      console.error('Ошибка при обновлении фразы:', err);
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Не удалось обновить фразу';
      alert(message);
    }
  };

  // Удалить фразу
  const handleDelete = async () => {
    if (!window.confirm('Удалить фразу?')) return;
    try {
      await api.delete(`/admin/analytics/phrase/${phrase.id}`);
      onDelete(); // Обновить список
    } catch (err) {
      console.error('Ошибка при удалении фразы:', err);
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Не удалось удалить фразу';
      alert(message);
    }
  };

  if (!roleNames.has('admin')) {
    return (
      <li className="d-flex justify-content-between align-items-center p-2 border rounded" style={{ background: '#f9f9f9' }}>
        <span><strong>{phrase.text}</strong></span>
        {theme.absolutely_everything && <small>Группа: {phrase.group}</small>}
      </li>
    );
  }

  return (
    <li className="d-flex flex-column gap-2 p-2 border rounded" style={{ background: '#f9f9f9' }}>
      <form onSubmit={handleUpdate}>
        <input type="hidden" name="update_phrase_id" value={phrase.id} />
        <input type="hidden" name="theme_id" value={theme.id} />
        <input type="hidden" name="project_id" value={projectId} />

        <div className="d-flex flex-wrap align-items-center gap-2">
          {/* Поле: текст фразы */}
          <div className="flex-grow-1" style={{ minWidth: '200px' }}>
            <input
              type="text"
              name="new_phrase_text"
              className="form-control form-control-sm"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Текст фразы"
              required
            />
          </div>

          {/* Поле: группа (только если absolutely_everything) */}
          {theme.absolutely_everything && (
            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
              <label className="small text-muted mb-0">Группа:</label>
              <input
                type="number"
                name="new_group"
                className="form-control form-control-sm"
                value={group}
                onChange={(e) => setGroup(e.target.value)}
                min="1"
                required
                style={{ width: '80px' }}
              />
            </div>
          )}

          {/* Кнопки: Сохранить и Удалить */}
          <div className="d-flex gap-1">
            <button type="submit" className="btn btn-sm btn-success">
              Сохранить
            </button>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={handleDelete}
            >
              Удалить
            </button>
          </div>
        </div>
      </form>
    </li>
  );
};

export default PhraseItem;





